var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlcx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.335 27.527v1.906a14.018 14.018 0 0 1-10.323-5.23H10.827v-.048l4.508 3.372zm1.034 1.917v-2.132l4.057-2.962h6.441a14.025 14.025 0 0 1-10.499 5.094zm0-5.094v1.682l2.303-1.682h-2.304zm8.698-1.035h-8.699V19.748l-.187-.155-4.991-4.16 4.588-7.8 9.288 15.682zM15.332 6.354l-4.946 8.408-3.459-2.883 8.948-6.847 9.162 7.219-3.683 2.762-5.13-8.662-.447-.754-.444.756zm6.552 9.556 2.369 4 .983-.703v-5.812l-3.352 2.515zm-6.55 4.322v6.003l-9.088-6.8V12.66l9.09 7.572zM5.27 11.845l.375.313h-.433v7.796l.207.155 1.495 1.118-1.467 2.167-.495.732a13.492 13.492 0 0 1-2.919-8.386c0-7.334 5.882-13.35 13.3-13.69v2.093l-9.55 7.308-.514.395zm21.15 11.724.457.77a13.5 13.5 0 0 0 3.088-8.599c0-7.431-6.037-13.508-13.596-13.7v2.066l9.704 7.645.197.157v7.832l-.216.154-1.272.909 1.638 2.766zm-16.912-.403-1.764-1.32-.893 1.32H9.51zM16 30.483c8.284 0 15-6.6 15-14.742 0-8.14-6.716-14.74-15-14.74S1 7.6 1 15.74c0 8.143 6.716 14.743 15 14.743z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcx);
export default __webpack_public_path__ + "static/media/ALCX.bbd9fcad20e3a33ba9e223ca11cc8e5d.svg";
export { ForwardRef as ReactComponent };